import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { groupPermissionGuard } from './common/guards/group-permission.guard';
import { downtimeGuard } from './common/guards/downtime.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/projects/reports'
  },
  {
    path: 'projects/reports',
    loadComponent: () => import('./manage-projects/reports/reports.component').then(c => c.ReportsComponent),
    canActivate: [MsalGuard, groupPermissionGuard]
  },
  {
    path: 'projects/explanations',
    loadComponent: () => import('./manage-projects/explanations/explanations.component').then(c => c.ExplanationsComponent),
    canActivate: [MsalGuard, groupPermissionGuard]
  },
  {
    path: 'administration/cutoff-date',
    loadComponent: () => import('./cutoff-date/cutoff-date.component').then(c => c.CutoffDateComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/timesheets',
    loadComponent: () => import('./manage-timesheets/manage-timesheets.component').then(c => c.ManageTimesheetsComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/manage-users',
    loadComponent: () => import('./manage-users/manage-users.component').then(c => c.ManageUsersComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/online-help',
    loadComponent: () => import('./online-help/online-help.component').then(c => c.OnlineHelpComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'administration/downtime',
    loadComponent: () => import('./downtime/downtime.component').then(c => c.DowntimeComponent),
    canActivate: [MsalGuard, groupPermissionGuard],
  },
  {
    path: 'unavailable',
    loadComponent: () => import('./unavailable/unavailable.component').then(c => c.UnavailableComponent),
    canActivate: [MsalGuard, downtimeGuard]
  },
  {
    path: 'not-authorized',
    loadComponent: () => import('./401/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
  },
  {
    path: 'logged-out',
    loadComponent: () => import('./logout/logout.component').then(c => c.LogoutComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./404/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
  }
];
